import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';

var environmentUserAgent;
var hasRequiredEnvironmentUserAgent;

function requireEnvironmentUserAgent () {
	if (hasRequiredEnvironmentUserAgent) return environmentUserAgent;
	hasRequiredEnvironmentUserAgent = 1;
	var globalThis = requireGlobalThis();

	var navigator = globalThis.navigator;
	var userAgent = navigator && navigator.userAgent;

	environmentUserAgent = userAgent ? String(userAgent) : '';
	return environmentUserAgent;
}

export { requireEnvironmentUserAgent as __require };
//# sourceMappingURL=node_modules-core-js-internals-environment-user-agent.js.map
